
angular.module('core')
  .service('dblLocation', ['$location', '$window', function($location, $window) {

    // TODO: consider https://github.com/medialize/URI.js
    var addUrlParameter = function (url, name, value) {
        var urlCopy = url.slice(0);
        var separator = urlCopy.indexOf('?') !== -1 ? '&' : '?';

        return urlCopy + separator + encodeURIComponent(name) + '=' + encodeURIComponent(value);
    };

    var getOrigin = function () {
        // IE10 window.location.origin is undefined
        if ($window.location.origin) {
            return $window.location.origin;
        }

        var portString = $location.port() ? ':' + $location.port() : '';

        return $location.protocol() + '://' + $location.host() + portString;
    };

    return {
        addUrlParameter: addUrlParameter,
        getOrigin: getOrigin
    };
  }]);
